import {combineReducers} from "redux";
import namespaceReducer from "./namespace_reducer"
import configReducer from "./configs_reducer"

export default combineReducers({
    namespaces: namespaceReducer,
    configs: configReducer
});